import {
  Alert,
  ErrorBoundary,
  LazyCodeBlock,
  Skeleton,
} from "@prismicio/editor-ui"
import { type ComponentProps, Suspense } from "react"

const lineHeight = 18
const headerHeight = 41
const contentPadding = 24

export function DeferredCodeBlock(props: ComponentProps<typeof LazyCodeBlock>) {
  const numberOfLines = props.code.split("\n").length

  return (
    <ErrorBoundary
      renderError={() => (
        <Alert
          icon="alert"
          title="Oops! We couldn't load the Code Block"
          color="error"
          noShadow
          footerButtons={{
            action: {
              onClick: () => window.location.reload(),
              text: "Refresh page",
            },
          }}
        />
      )}
    >
      <Suspense
        fallback={
          <Skeleton
            // NOTE: Match the height of the CodeBlock
            height={headerHeight + contentPadding + numberOfLines * lineHeight}
            borderRadius={6}
          />
        }
      >
        <LazyCodeBlock {...props} />
      </Suspense>
    </ErrorBoundary>
  )
}
